<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Sites</h4>
        <hr>
      </div>
    </div>
    <div class="alert alert-warning" role="alert">
          <b>Notice:</b> Updating the school list requires a restart.
        </div>
    <div class="row" v-if="[3].includes(logged_in_user.group_id)">
      <div class="col-md-12 col-lg-4">
        <router-link :to="{ name:'AdminSiteAdd' }" class="btn btn-success"><i class="fa fa-edit" aria-hidden="true"></i>
          Add Site
        </router-link>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-12">
        <table class="table table-striped">
          <thead class="bg-hub-primary text-white">
          <tr>
            <th>Name</th>
            <th class="hidden-sm-down">IP</th>
            <th class="hidden-sm-down">Extension Prefix</th>
            <th>Manage</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="site in sites" :key="site.site_id">
            <td>{{ site.name }}</td>
            <td class="hidden-sm-down">{{ site.ip }}</td>
            <td>{{ site.extension_prefix }}</td>
            <td>
              <div class="dropdown">
                <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fa fa-cogs fa-fw" aria-hidden="true"></i>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <router-link :to="{ name:'AdminSiteEdit', params: { site_id: site.site_id } }"
                               class="dropdown-item" v-if="[3].includes(logged_in_user.group_id)"><i
                    class="fa fa-pencil-alt fa-fw" aria-hidden="true"></i>&nbsp;Edit
                  </router-link>
                  <a class="dropdown-item" href="#" onclick="return false" @click="deleteSite(site)"
                     v-if="[3].includes(logged_in_user.group_id) && site.site_id !== 1"><i
                    class="fa fa-trash fa-fw" aria-hidden="true"></i>&nbsp;Delete</a>
                  <div class="dropdown-divider" v-if="[3].includes(logged_in_user.group_id)"></div>
                  <router-link :to="{ name: 'AdminSiteManageLandingPage', params: { site_id: site.site_id } }" class="dropdown-item" v-if="[3, 4].includes(logged_in_user.group_id)">
                    <i class="fa fa-plane-arrival fa-fw" aria-hidden="true"></i>&nbsp;Landing Page
                  </router-link>
                  <router-link :to="{ name:'AdminSiteFeatures', params: { site_id: site.site_id} }" class="dropdown-item" v-if="[3, 4].includes(logged_in_user.group_id)">
                    <i class="fa fa-box fa-fw" aria-hidden="true"></i>&nbsp;Features
                  </router-link>
                  <router-link :to="{ name:'AdminSiteManageLogo', params: { site_id: site.site_id} }" class="dropdown-item" v-if="[3, 4].includes(logged_in_user.group_id)">
                    <i class="fa fa-image fa-fw" aria-hidden="true"></i>&nbsp;Logo
                  </router-link>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: mapGetters({
    sites: 'allSites',
    logged_in_user: 'loggedInUser'
  }),
  created () {
    this.$store.dispatch('getSites')
  },
  methods: {
    ...mapActions(['deleteSite'])
  }
}
</script>

<style scoped>

</style>
